<template>
    <span>

       <div class="row" v-show="itemCount > 0">
            <div class="col-12">
                Tooteid kokku: <b>{{itemCount}}</b>
            </div>
        </div>

        <div class="row" v-if="!searching && itemCount > 0">
            <div class="col-12">
                <list
                        v-bind:search-term="searchTerm"
                        v-on:search="search"
                ></list>
            </div>
        </div>

    </span>
</template>

<script>

    import List from './List'

    export default {
        name: "Parser",
        props: ['searchTerm', 'itemCount', 'searching'],
        components: {
            'list': List,
        },
        methods: {
            search: function(searchTerm){
                this.$emit('search', searchTerm);
            },
        },
    }

</script>

<style scoped>

</style>